// Copyright © 2021 Move Closer
export var ModalMode;
(function (ModalMode) {
    ModalMode["Default"] = "modal";
    ModalMode["Drawer"] = "drawer";
})(ModalMode || (ModalMode = {}));
